import TeamMemberCard from "components/TeamMemberCard"
import richText from "utilities/richText"

export default function FeaturedTeamMember({ blok }) {
  const teamMembers = Array.isArray(blok.team_members) ? blok.team_members.filter((member) => member?.content) : []

  return (
    <section className="px-5">
      <div className="featured-team-member-section max-w-screen-xl mx-auto py-12">
        <div className="basis-1/2 featured-team-member-heading">
          <h2 className="flex flex-col">
            {blok?.eyebrow ? <span className="uppercase pb-2 text-primary eyebrow">{blok.eyebrow}</span> : null}
            <span className="block text-primary">{blok?.heading}</span>
          </h2>
        </div>
        <div className="featured-team-member-content">{richText(blok?.content)}</div>
        <div className="featured-team-member-cards basis-1/2 grid grid-cols-2 gap-4 lg:gap-7">
          {teamMembers.map((member) => (
            <TeamMemberCard {...{ ...member.content, slug: member.full_slug }} key={member.uuid} />
          ))}
        </div>
      </div>
    </section>
  )
}
